import React from 'react';


export const Footer = () => {
    const footerStyles = {
        position: 'fixed' as 'fixed',
        left: 0,
        bottom: 0,
        width: '100%',
        backgroundColor: '#333',
        color: 'white',
        textAlign: 'center' as 'center',
        padding: '5px 0',
    };

    return (
        <div style={footerStyles}>
            <a href="https://www.buymeacoffee.com/playersnapshot" target="_blank" rel="noopener noreferrer">
                <img
                    src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                    alt="Buy Me A Coffee"
                    style={{
                        height: '50px',
                        width: '200px'
                    }}
                />
            </a>
        </div>
    );
};
